import { applicantDashboardConstants } from "../../_constants/hiringManager/applicantDashboard.constants";

const initialState = {};

export const get_applicant_hiring_progress_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case applicantDashboardConstants.GET_APPLICANT_HIRING_PROGRESS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case applicantDashboardConstants.GET_APPLICANT_HIRING_PROGRESS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case applicantDashboardConstants.GET_APPLICANT_HIRING_PROGRESS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    case applicantDashboardConstants.RESET_ACTION:
      return {
        type: "alert-reset",
        data: {},
      };
    default:
      return state;
  }
};

export const update_applicant_hiring_progress_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case applicantDashboardConstants.UPDATE_APPLICANT_HIRING_PROGRESS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case applicantDashboardConstants.UPDATE_APPLICANT_HIRING_PROGRESS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case applicantDashboardConstants.UPDATE_APPLICANT_HIRING_PROGRESS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    case applicantDashboardConstants.RESET_ACTION:
      return {
        type: "alert-reset",
        data: {},
      };
    default:
      return state;
  }
};

export const get_applicant_comments_list_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case applicantDashboardConstants.GET_COMMENTS_LIST_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case applicantDashboardConstants.GET_COMMENTS_LIST_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case applicantDashboardConstants.GET_COMMENTS_LIST_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    case applicantDashboardConstants.RESET_ACTION:
      return {
        type: "alert-reset",
        data: {},
      };
    default:
      return state;
  }
};

export const get_applicant_profile_info_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case applicantDashboardConstants.RESET_ACTION:
      return {
        type: "alert-reset",
        applicantProfileData: {},
      };
    case applicantDashboardConstants.GET_APPLICANT_PROFILE_ACTION_REQUEST:

      return {
        type: "alert-success",
        message: action.payload,
        applicantProfileData: {},
      };
    case applicantDashboardConstants.GET_APPLICANT_PROFILE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        applicantProfileData: action.payload,
      };
    case applicantDashboardConstants.GET_APPLICANT_PROFILE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };

    default:
      return state;
  }
};

export const get_applicant_hms_videos_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case applicantDashboardConstants.RESET_ACTION:
      return {
        type: "alert-reset",
        applicantHmsVideosData: {},
      };
    case applicantDashboardConstants.GET_APPLICANT_HMS_VIDEOS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case applicantDashboardConstants.GET_APPLICANT_HMS_VIDEOS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        applicantHmsVideosData: action.payload,
      };
    case applicantDashboardConstants.GET_APPLICANT_HMS_VIDEOS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_applicant_submitted_assessment_kits_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case applicantDashboardConstants.RESET_ACTION:
      return {
        type: "alert-reset",
        applicantSubmittedAssessmentKitsData: {},
      };
    case applicantDashboardConstants.GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case applicantDashboardConstants.GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        applicantSubmittedAssessmentKitsData: action.payload,
      };
    case applicantDashboardConstants.GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_applicant_offer_terms_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case applicantDashboardConstants.RESET_ACTION:
      return {
        type: "alert-reset",
        applicantOfferTermsData: {},
      };
    case applicantDashboardConstants.GET_APPLICANT_OFFER_TERMS_ACTION_REQUEST:
    case applicantDashboardConstants.CREATE_APPLICANT_OFFER_TERMS_ACTION_REQUEST:
    case applicantDashboardConstants.UPDATE_APPLICANT_OFFER_TERMS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case applicantDashboardConstants.GET_APPLICANT_OFFER_TERMS_ACTION_SUCCESS:
    case applicantDashboardConstants.CREATE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS:
    case applicantDashboardConstants.UPDATE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        applicantOfferTermsData: action.payload,
      };
    case applicantDashboardConstants.GET_APPLICANT_OFFER_TERMS_ACTION_FAILURE:
    case applicantDashboardConstants.CREATE_APPLICANT_OFFER_TERMS_ACTION_FAILURE:
    case applicantDashboardConstants.UPDATE_APPLICANT_OFFER_TERMS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
